<template>
  <div v-if="appErrors.length > 0 && !showErrors">
    <errorItem
      v-for="(msg, index) in appErrors"
      :key="index"
      :index="index"
      :msg="msg"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import errorItem from './ErrorItem.vue';

export default {
  name: 'main-errors',
  components: {
    errorItem,
  },
  computed: {
    ...mapGetters('app', [
      'appErrors',
    ]),
    showErrors() {
      const routeName = this.$route.name;
      return routeName === 'login'
        || routeName === 'recive-password'
        || routeName === 'reset-password'
        || routeName === 'login-unblock';
    },
  },
};
</script>
